// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,300;0,400;0,700;1,400&display=swap);"]);
// Module
exports.push([module.id, ".bx--dropdown[data-v-a55ee370]{border-bottom:none}.print-positions-manager[data-v-a55ee370]{font-family:Roboto,sans-serif}.print-positions-manager .wrapper[data-v-a55ee370]{display:flex;justify-content:center}.full-width--fix[data-v-a55ee370]{padding-left:1rem;padding-right:1rem}.techniques[data-v-a55ee370]{flex-wrap:wrap}.more-details[data-v-a55ee370]{font-size:14px;margin-top:15px;margin-bottom:15px}", ""]);
// Exports
module.exports = exports;
